export const getValueFromFormattedPrice = (price: string) => {
  const value = price.replace(/[^0-9,]/g, '').replace(',', '.');

  return Number(value);
};
